function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from '@shared/routerHistory';
import { AppDetails as AppDetailsComponent } from '@appsource/components/appDetails';
import { ensureAppDetailsData, ensureAppReviewsData, loadLinkedInProductGroup } from '@shared/actions/thunkActions';
import { createInstructionsModalAction, createRatingAction } from '@shared/actions/actions';
import { getTelemetryDetailContentCurrentView, getTransactCTATypes } from '@shared/utils/appUtils';
import { isOneTimePaymentOffer } from '@shared/utils/onetimepaymentoffers';
import { withHydration } from '@shared/hooks/useHydration';
import { createSetCheckoutSource } from '@shared/actions/checkoutActions';
import { getUserPrivateOffers } from '@shared/actions/privateOffersThunkActions';
export const mapStateToProps = (state, ownProps)=>{
    var _state_users_profile, _state_apps_relatedAppsItems_items, _state_apps_relatedAppsItems, _state_apps_relatedAppsItems_items1, _state_apps_relatedAppsItems1, _state_apps_relatedAppsItems_items2, _state_apps_relatedAppsItems2;
    const entityId = ownProps.routeParams.entityId.toString().toLowerCase();
    const isPrivate = !!ownProps.routeParams.privateOffer;
    const { billingCountryCode, breadcrumbUrl: stateBreadcrumbUrl, correlationId, currentGalleryViewIsCurated, currentView, featureFlags, locale, nationalCloud, isEmbedded } = state.config;
    const { openInNewWindowButton } = featureFlags;
    const appList = state.apps.dataList;
    const hashMap = state.apps.idMap;
    const query = ownProps.location ? ownProps.location.query : null;
    const appIndex = hashMap[`${entityId}`];
    let targetApp = null;
    if (appIndex >= 0) {
        targetApp = appList[`${appIndex}`];
    }
    const uiRole = state.users.profile && state.users.profile.uiRole;
    const managedLicenses = ((_state_users_profile = state.users.profile) === null || _state_users_profile === void 0 ? void 0 : _state_users_profile.managedLicenses) || [];
    const doesTenantHasLicenseForApp = Boolean(targetApp === null || targetApp === void 0 ? void 0 : targetApp.bigId) && managedLicenses.some((x)=>x.productId === targetApp.bigId);
    const ctaTypes = getTransactCTATypes(targetApp, uiRole, doesTenantHasLicenseForApp, isEmbedded, billingCountryCode);
    if (ctaTypes) {
        targetApp.ctaTypes = ctaTypes;
    }
    const breadcrumbUrl = stateBreadcrumbUrl || '/' + locale + '/marketplace/apps';
    const defaultTab = (query === null || query === void 0 ? void 0 : query.tab) ? query.tab : null;
    const isOneTimePayment = isOneTimePaymentOffer(entityId);
    const hideBreadcrumbUrl = isOneTimePayment;
    var _state_apps_relatedAppsItems_items_saasLinkingItems, _state_apps_relatedAppsItems_items_linkedAddIns;
    return _object_spread_props(_object_spread({}, ownProps), {
        entityId,
        app: targetApp,
        startingPrice: targetApp ? targetApp.startingPrice : null,
        breadcrumbUrl,
        defaultTab,
        allApps: appList,
        nationalCloud,
        billingCountryCode,
        correlationId,
        currentView: getTelemetryDetailContentCurrentView(currentView, currentGalleryViewIsCurated),
        userInfo: state.users,
        isLoadingUserData: state.users.loading,
        isLoadingUserProfile: state.users.isLoadingUserProfile,
        parentApps: (_state_apps_relatedAppsItems_items_saasLinkingItems = (_state_apps_relatedAppsItems = state.apps.relatedAppsItems) === null || _state_apps_relatedAppsItems === void 0 ? void 0 : (_state_apps_relatedAppsItems_items = _state_apps_relatedAppsItems.items) === null || _state_apps_relatedAppsItems_items === void 0 ? void 0 : _state_apps_relatedAppsItems_items.saasLinkingItems) !== null && _state_apps_relatedAppsItems_items_saasLinkingItems !== void 0 ? _state_apps_relatedAppsItems_items_saasLinkingItems : null,
        linkedAddIns: (_state_apps_relatedAppsItems_items_linkedAddIns = (_state_apps_relatedAppsItems1 = state.apps.relatedAppsItems) === null || _state_apps_relatedAppsItems1 === void 0 ? void 0 : (_state_apps_relatedAppsItems_items1 = _state_apps_relatedAppsItems1.items) === null || _state_apps_relatedAppsItems_items1 === void 0 ? void 0 : _state_apps_relatedAppsItems_items1.linkedAddIns) !== null && _state_apps_relatedAppsItems_items_linkedAddIns !== void 0 ? _state_apps_relatedAppsItems_items_linkedAddIns : null,
        locale,
        suggestedItems: ((_state_apps_relatedAppsItems2 = state.apps.relatedAppsItems) === null || _state_apps_relatedAppsItems2 === void 0 ? void 0 : (_state_apps_relatedAppsItems_items2 = _state_apps_relatedAppsItems2.items) === null || _state_apps_relatedAppsItems_items2 === void 0 ? void 0 : _state_apps_relatedAppsItems_items2.suggestedItems) || [],
        uiRole,
        isPrivate,
        isEmbedded,
        doesTenantHasLicenseForApp,
        hideBreadcrumbUrl,
        linkedInProductGroup: state.apps.linkedInProductGroup,
        openInNewWindowButtonFlag: openInNewWindowButton
    });
};
function ensureAsyncData(dispatch, entityId, isPrivate) {
    return dispatch(ensureAppDetailsData(entityId, isPrivate));
}
export const mapDispatchToProps = (dispatch)=>{
    return {
        setCheckoutSourcePDP: ({ source })=>dispatch(createSetCheckoutSource({
                source
            })),
        ensureAsyncData: ({ entityId, isPrivate })=>ensureAsyncData(dispatch, entityId, isPrivate),
        ensureAppReviewsData: (entityId, forceUpdate = false)=>dispatch(ensureAppReviewsData(entityId, forceUpdate)),
        openInstructionsModal: ()=>dispatch(createInstructionsModalAction({
                showModal: true,
                isFromDownload: false
            })),
        openRatingModal: (app, accessKey, ctaType, callback)=>dispatch(createRatingAction({
                showModal: true,
                app: app,
                accessKey: accessKey,
                ctaType: ctaType,
                callback: callback
            })),
        fetchUserPrivateOffers: ()=>dispatch(getUserPrivateOffers()),
        loadLinkedInProductGroup: (args)=>dispatch(loadLinkedInProductGroup(args))
    };
};
const AppDetails = withRouter(connect(mapStateToProps, mapDispatchToProps)(withHydration(AppDetailsComponent)));
export const ensureAsyncDataSSR = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function*(dispatch, getState, params) {
        const isPrivate = !!params.privateOffer;
        if (isPrivate) {
            return;
        }
        yield ensureAsyncData(dispatch, params.entityId, false);
    });
    return function ensureAsyncDataSSR(dispatch, getState, params) {
        return _ref.apply(this, arguments);
    };
}();
export default AppDetails;
